import { getPortalSettingsRootUrl } from './utils';
export function getPaidUserSettingsUrl(userName) {
  const params = userName ? `?userName=${encodeURIComponent(userName)}` : '';
  return `${getPortalSettingsRootUrl()}/users/paid-users${params}`;
}